module.exports = __webpack_public_path__ + "static/media/37_A.3ea25b3d.png";